var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.69168 0 0 2.69154 0 6C0 9.30846 2.69168 12 6 12C9.30846 12 12 9.30846 12 6C12 2.69154 9.30832 0 6 0ZM6 11.1241C3.17461 11.1241 0.875906 8.82539 0.875906 6C0.875906 3.17461 3.17461 0.875906 6 0.875906C8.82539 0.875906 11.1241 3.17459 11.1241 5.99986C11.1241 8.82539 8.82539 11.1241 6 11.1241Z",
    fill: "#444851"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04373 5.99981H6.14593V3.37207C6.14593 3.13017 5.94987 2.93411 5.70797 2.93411C5.46607 2.93411 5.27002 3.13017 5.27002 3.37207V6.43776C5.27002 6.67966 5.46607 6.87571 5.70797 6.87571H8.04373C8.28563 6.87571 8.48168 6.67966 8.48168 6.43776C8.48168 6.19586 8.28563 5.99981 8.04373 5.99981Z",
    fill: "#444851"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuration);
export default __webpack_public_path__ + "static/media/duration.864bbb3d3261b18496c4cff52dfb3695.svg";
export { ForwardRef as ReactComponent };